import React from "react";
import { useSelector } from "react-redux";

interface ProtectedComponentProps {
  role: string;
  children: React.ReactNode;
}

const ProtectedComponent = (props: ProtectedComponentProps) => {
  const { role, children } = props;

  const user = useSelector((state: any) => state.settings.user);

  if (user && user.role !== role) {
    return null;
  }
  return children;
};

export default ProtectedComponent;
